import { getLimitOptions } from 'utilities/query';
import templateUrl from './regulator-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    query: '<',
    regulators: '<',
    selectedRegulators: '<',
    userLockoutChanged: '&',
    queryChanged: '&',
    searchTextChanged: '&'
  },
  controller: class RegulatorListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });

      this.onPaginationChanged = (page, take) => {
        this.onQueryChange({
          ...this.query,
          page,
          take
        });
      };

      this.onOrderChanged = (order) => {
        const direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        const orderBy = order.replace('-', '');

        this.onQueryChange({
          ...this.query,
          direction,
          orderBy
        });
      };
    }

    $onInit() {
      this.limitOptions = getLimitOptions();
    }

    onQueryChange(query) {
      this.queryChanged(
        this.EventEmitter({
          query
        })
      );
    }

    onSearchTextChanged(searchText) {
      this.searchTextChanged(
        this.EventEmitter({
          searchText
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/companies/regulator-list/regulator-list.component.js